import { useCourseDetailTranslation } from '../hooks';

const CourseLevel: React.FC<{ courseLevel: string }> = ({ courseLevel }) => {
  const { t } = useCourseDetailTranslation();

  return (
    <section className="tw-py-2.4">
      <p className="tw-mb-1.6 tw-font-caption">{t('LEVEL_TITLE')}</p>
      <h2 className="tw-mb-1.6 tw-font-h4 text-primary-main">{courseLevel}</h2>
    </section>
  );
};

export default CourseLevel;
